import { useMemo } from "react";
import { useClaritySession } from "@/lib/auth/auth-store";
import type { Permission } from "@/lib/auth/permissions";

export function usePermissions() {
  const session = useClaritySession();

  return useMemo(() => {
    const permissions =
      session.status === "authenticated" ? session.permissions : [];
    const permissionSet = new Set(permissions);

    return {
      permissions,
      hasPermission: (permission: Permission) => permissionSet.has(permission),
      hasAnyPermission: (required: Permission[]) =>
        required.some((permission) => permissionSet.has(permission)),
      hasAllPermissions: (required: Permission[]) =>
        required.every((permission) => permissionSet.has(permission)),
    };
  }, [session]);
}
